"use strict";

module.exports = answerFilter;

/*@ngInject*/
function answerFilter($filter) {
    return function (string) {
        return string.replace(/_/g, ", ");
    };
}


/** WEBPACK FOOTER **
 ** ./app/shared/filters/answer.filter.js
 **/